import React, { useEffect } from "react";
import { motion } from "framer-motion";

import womanImg from "../images/step5_girl.png";
import bubbleImg from "../images/bubble_appreciate.png"; // bubble baru

const Appreciate = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  // Saat halaman dibuka → pastikan status selesai disimpan
  useEffect(() => {
    if (!student) return;

    // Jika sudah selesai sebelumnya, tidak perlu update ulang
    if (student.current_step === "done") return;

    // Update ke database
    fetch(`http://localhost:3000/student-demography/${student.student_id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ current_step: "done" }),
    })
      .then(() => {
        // Update localStorage juga
        const updated = { ...student, current_step: "done" };
        localStorage.setItem("student", JSON.stringify(updated));
      })
      .catch((err) => console.error("Failed to update current_step:", err));
  }, [student]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 flex flex-col items-center text-white relative px-4 overflow-hidden">

      {/* WOMAN + BUBBLE */}
      <div className="relative mt-16 flex items-start justify-center">

        {/* EXTRA LARGE Woman */}
        <img
          src={womanImg}
          alt="woman smiling"
          className="w-[330px] md:w-[420px] drop-shadow-xl z-10"
        />

        {/* Bubble Appreciate */}
        <img
          src={bubbleImg}
          alt="bubble appreciate"
          className="w-[260px] md:w-[350px] ml-[-120px] mt-[-20px] drop-shadow-xl"
        />
      </div>

      {/* QUOTE TEXT */}
      <p className="mt-10 text-center font-extrabold text-yellow-300 text-lg md:text-xl drop-shadow-md">
        “Let's make enjoyment our pathway to achievement!”
      </p>

      {/* NEXT BUTTON */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => (window.location.href = "/Dashboard")}
        className="
          mt-6 bg-yellow-300 text-blue-900 font-bold
          px-10 py-3 rounded-full text-lg shadow-md
        "
      >
        Next ➤
      </motion.button>

      {/* FOOTER */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Appreciate;
